import React, { useState } from 'react';
import { Spin, Alert } from 'antd';
import { usePW9341Query } from './hooks/usePW9341Query';
import QueryParams from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryRequest } from '../../services/pw9341Api';
import './PW9341Form.css';

const PW9341Form: React.FC = () => {
  const { loading, result, queried, noData, runQuery } = usePW9341Query();

  const [year, setYear] = useState(new Date().getFullYear());
  const [deptFrom, setDeptFrom] = useState('');
  const [deptTo, setDeptTo] = useState('');
  const [empFrom, setEmpFrom] = useState('');
  const [empTo, setEmpTo] = useState('');

  const handleQuery = () => {
    const req: QueryRequest = {
      year,
      deptFrom: deptFrom.trim(),
      deptTo: deptTo.trim() || 'ZZZZ',
      empFrom: empFrom.trim(),
      empTo: empTo.trim() || 'ZZZZZZZZ',
    };
    runQuery(req);
  };

  return (
    <Spin spinning={loading}>
      <div className="pw9341-container max-w-7xl mx-auto p-4">
        <h2 className="text-xl font-bold mb-4">
          個人年度薪資異動 (pw9341f1)
        </h2>

        <QueryParams
          year={year}
          deptFrom={deptFrom}
          deptTo={deptTo}
          empFrom={empFrom}
          empTo={empTo}
          loading={loading}
          onYearChange={setYear}
          onDeptFromChange={setDeptFrom}
          onDeptToChange={setDeptTo}
          onEmpFromChange={setEmpFrom}
          onEmpToChange={setEmpTo}
          onQuery={handleQuery}
        />

        {queried && !noData && result && (
          <ResultTable result={result} />
        )}

        {queried && noData && (
          <Alert
            message="查無資料"
            description="查無符合條件的薪資異動資料！請確認篩選條件是否正確。"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};

export default PW9341Form;
